export default __webpack_public_path__ + "static/media/dealing-with-difficulties.c2c25f61.pdf";